<template>
    <el-input type="serach" clearable :placeholder="$t('Home.helpCenter.MobileSerachHead.SearchTutorialOrFAQ')" v-model="input"  prefix-icon="el-icon-search" @change="handleSearch"> </el-input>
</template>

<script>
export default {
  data() {
    return {
      input: ''
    }
  },
  created() {
    if (this.$route.query.keyword) {
      this.input = this.$route.query.keyword
    }
  },
  methods: {
    handleSearch() {
      this.$emit('change', this.input)
      this.$router.push({
        path: '/help-center/search-center',
        query: {
          keyword: this.input
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

/deep/.el-input--medium .el-input__inner {
  height: 0.8rem;
}
</style>
